import { render, staticRenderFns } from "./CmdDialogButton.vue?vue&type=template&id=8a8f07a2&scoped=true&"
import script from "./CmdDialogButton.vue?vue&type=script&lang=js&"
export * from "./CmdDialogButton.vue?vue&type=script&lang=js&"
import style0 from "./CmdDialogButton.vue?vue&type=style&index=0&id=8a8f07a2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8f07a2",
  null
  
)

export default component.exports